// Interface for module data transfer object
export interface IModuleDto {
  _id?: string; // Optional since it's used in updates
  moduleName: string; // Name of the module
  isSubModule: boolean;
  submodules: SubModule[];
}
export interface SubModule {
  isSubModule: boolean;
  moduleId: string;
  moduleName: string;
}
// Interface for module query parameters data transfer object
export interface ModuleQueryParamsDTO {
  pageNum?: number; // Optional: page number for pagination
  pageLimit?: number; // Optional: limit of items per page for pagination
  search?: string; // Optional: search term
  module_name: string; // Name of the module
}
